declare namespace $ {

	type $bog_theme_toggle__theme_auto_bog_lk_1 = $mol_type_enforce<
		ReturnType< $bog_lk['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type __bog_lk_2 = $mol_type_enforce<
		Parameters< $bog_lk['back_click'] >[0]
		,
		Parameters< ReturnType< $bog_lk['Back'] >['click'] >[0]
	>
	type $mol_text__text_bog_lk_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_bog_lk_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_bog_lk_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_lk_avatar__entity_bog_lk_6 = $mol_type_enforce<
		ReturnType< $bog_lk['profile'] >
		,
		ReturnType< $bog_lk_avatar['entity'] >
	>
	type $bog_lk_avatar__enabled_bog_lk_7 = $mol_type_enforce<
		ReturnType< $bog_lk['can_edit'] >
		,
		ReturnType< $bog_lk_avatar['enabled'] >
	>
	type $mol_text__text_bog_lk_8 = $mol_type_enforce<
		ReturnType< $bog_lk['display_name_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_lk_9 = $mol_type_enforce<
		ReturnType< $bog_lk['username_preview_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_lk_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_lk_11 = $mol_type_enforce<
		ReturnType< $bog_lk['peer_id'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_labeler__Label_bog_lk_12 = $mol_type_enforce<
		ReturnType< $bog_lk['Peer_label'] >
		,
		ReturnType< $mol_labeler['Label'] >
	>
	type $mol_labeler__Content_bog_lk_13 = $mol_type_enforce<
		ReturnType< $bog_lk['Peer_value'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_text__text_bog_lk_14 = $mol_type_enforce<
		ReturnType< $bog_lk['bio_preview_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_bog_lk_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_bog_lk_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_bog_lk_17 = $mol_type_enforce<
		ReturnType< $bog_lk['share_link'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type __bog_lk_19 = $mol_type_enforce<
		Parameters< $bog_lk['share_copy_click'] >[0]
		,
		Parameters< ReturnType< $bog_lk['Share_copy'] >['click'] >[0]
	>
	type $mol_text__text_bog_lk_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_bog_lk_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__sub_bog_lk_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_row__sub_bog_lk_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_text__text_bog_lk_24 = $mol_type_enforce<
		ReturnType< $bog_lk['share_feedback_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_bog_lk_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_row__sub_bog_lk_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_bog_lk_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_text__text_bog_lk_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_lk_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_bog_lk_30 = $mol_type_enforce<
		ReturnType< $bog_lk['full_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_33 = $mol_type_enforce<
		ReturnType< $bog_lk['Full_name_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_34 = $mol_type_enforce<
		ReturnType< $bog_lk['nickname'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_37 = $mol_type_enforce<
		ReturnType< $bog_lk['Nickname_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_textarea__value_bog_lk_38 = $mol_type_enforce<
		ReturnType< $bog_lk['bio'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_bog_lk_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_form_field__name_bog_lk_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_41 = $mol_type_enforce<
		ReturnType< $bog_lk['Bio_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form_group__sub_bog_lk_42 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_text__text_bog_lk_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_bog_lk_44 = $mol_type_enforce<
		ReturnType< $bog_lk['city'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_47 = $mol_type_enforce<
		ReturnType< $bog_lk['City_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_48 = $mol_type_enforce<
		ReturnType< $bog_lk['country'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_51 = $mol_type_enforce<
		ReturnType< $bog_lk['Country_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form_group__sub_bog_lk_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_text__text_bog_lk_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__value_bog_lk_54 = $mol_type_enforce<
		ReturnType< $bog_lk['email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_57 = $mol_type_enforce<
		ReturnType< $bog_lk['Email_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_58 = $mol_type_enforce<
		ReturnType< $bog_lk['website'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_60 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_61 = $mol_type_enforce<
		ReturnType< $bog_lk['Website_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_62 = $mol_type_enforce<
		ReturnType< $bog_lk['telegram'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_63 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_64 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_65 = $mol_type_enforce<
		ReturnType< $bog_lk['Telegram_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_66 = $mol_type_enforce<
		ReturnType< $bog_lk['github'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_68 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_69 = $mol_type_enforce<
		ReturnType< $bog_lk['Github_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_bog_lk_70 = $mol_type_enforce<
		ReturnType< $bog_lk['twitter'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_lk_71 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_bog_lk_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_bog_lk_73 = $mol_type_enforce<
		ReturnType< $bog_lk['Twitter_input'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form_group__sub_bog_lk_74 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_group['sub'] >
	>
	type $mol_form__body_bog_lk_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['body'] >
	>
	export class $bog_lk extends $mol_page {
		Theme( ): $bog_theme_auto
		Lights( ): $bog_theme_toggle
		back_click( next?: ReturnType< ReturnType< $bog_lk['Back'] >['click'] > ): ReturnType< ReturnType< $bog_lk['Back'] >['click'] >
		Back_text( ): $mol_text
		Back( ): $mol_button_minor
		Avatar( ): $bog_lk_avatar
		display_name_text( ): string
		Display_name( ): $mol_text
		username_preview_text( ): string
		Username_preview( ): $mol_text
		Peer_label( ): $mol_text
		peer_id( ): string
		Peer_value( ): $mol_text
		Peer_id( ): $mol_labeler
		bio_preview_text( ): string
		Bio_preview( ): $mol_text
		Hero_info( ): $mol_list
		Share_title( ): $mol_text
		share_link( ): string
		Share_field( ): $mol_string
		share_copy_click( next?: ReturnType< ReturnType< $bog_lk['Share_copy'] >['click'] > ): ReturnType< ReturnType< $bog_lk['Share_copy'] >['click'] >
		Share_copy_text( ): $mol_text
		Share_copy( ): $mol_button_minor
		Share_row( ): $mol_row
		share_feedback_text( ): string
		Share_feedback( ): $mol_text
		Share_panel( ): $mol_list
		Hero_meta( ): $mol_row
		Hero( ): $mol_row
		Form_title( ): $mol_text
		Basics_heading( ): $mol_text
		full_name( next?: string ): string
		Full_name_input( ): $mol_string
		Full_name_field( ): $mol_form_field
		nickname( next?: string ): string
		Nickname_input( ): $mol_string
		Nickname_field( ): $mol_form_field
		bio( next?: string ): string
		Bio_input( ): $mol_textarea
		Bio_field( ): $mol_form_field
		Basics_group( ): $mol_form_group
		Location_heading( ): $mol_text
		city( next?: string ): string
		City_input( ): $mol_string
		City_field( ): $mol_form_field
		country( next?: string ): string
		Country_input( ): $mol_string
		Country_field( ): $mol_form_field
		Location_group( ): $mol_form_group
		Contacts_heading( ): $mol_text
		email( next?: string ): string
		Email_input( ): $mol_string
		Email_field( ): $mol_form_field
		website( next?: string ): string
		Website_input( ): $mol_string
		Website_field( ): $mol_form_field
		telegram( next?: string ): string
		Telegram_input( ): $mol_string
		Telegram_field( ): $mol_form_field
		github( next?: string ): string
		Github_input( ): $mol_string
		Github_field( ): $mol_form_field
		twitter( next?: string ): string
		Twitter_input( ): $mol_string
		Twitter_field( ): $mol_form_field
		Contacts_group( ): $mol_form_group
		Profile_form( ): $mol_form
		title( ): string
		plugins( ): readonly(any)[]
		head( ): readonly(any)[]
		profile( ): any
		can_edit( next?: boolean ): boolean
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=lk.view.tree.d.ts.map